import { render } from "./modal_suivi_details.vue?vue&type=template&id=3ec3f3f2"
import script from "./modal_suivi_details.vue?vue&type=script&lang=js"
export * from "./modal_suivi_details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__